import React, { useEffect, useState } from "react";
import { noop } from "utils/common";
import { isLegacyPreview, PreviewCreative, LegacyPreviewCreative } from "utils/Preview";

import "./CreativePreview.css";

export default function CreativePreview({
	keyId,
	adType,
	origin,
	creativeId,
	height,
	width,
	onLoad,
}) {
	const creativePreview = (id) => {
		if(width < 0 || height < 0){ return null;}

		let reloadedKey = `.%${id}`;
		const src = isLegacyPreview({ adType, origin }) ? LegacyPreviewCreative.basic(creativeId) : PreviewCreative.basic(creativeId);

		return (
			<iframe
				key={reloadedKey}
				className="creative-preview-frame"
				src={src}
				allowFullScreen
				onLoad={onLoad}
			/>
		);
	};

	let [frame, setFrame] = useState(creativePreview(0));

	useEffect(()=>{
		setFrame(creativePreview(keyId));
	}, [keyId, width, height]);

	return (
		<div className="creative-preview-frame">
			{frame}
		</div>
	);
}

CreativePreview.displayName = "CreativePreview";
CreativePreview.defaultProps = {
	keyId:117,
	width:-1,
	height:-1,
	onLoad: noop,
	creativeId:-1,
};
